import React from 'react';
import CargaTarjeta from '../../comun/CargaTarjeta';

/**
 * Tarjeta «Crédito por gastos en educación» del AT 2026: el Excel «Detalle_DJ_11»
 * (formulario de cesión del crédito del art. 55 ter LIR) que el SII entrega a la persona.
 * Su lector está en src/services/declaracionRenta/empresarioIndividual/2026/educacion/lector.js
 */
const COLUMNAS = [
  { campo: 'nombre_hijo', titulo: 'Hijo o hija' },
  { campo: 'rut_hijo', titulo: 'RUT' },
  { campo: 'nombre_otro_padre', titulo: 'Otro padre o madre' },
  { campo: 'rut_otro_padre', titulo: 'RUT otro padre o madre' },
  { campo: 'cede_beneficio', titulo: 'Cede' },
  { campo: 'le_cedieron_beneficio', titulo: 'Le cedieron' },
  { campo: 'porcentaje_credito', titulo: 'Crédito', formato: 'porcentaje' },
  { campo: 'establecimiento', titulo: 'Establecimiento' },
  { campo: 'cumple_requisitos', titulo: 'Cumple requisitos' },
];

const EducacionPage = ({ anioTributario, idCompany }) => (
  <CargaTarjeta
    anioTributario={anioTributario}
    idCompany={idCompany}
    tarjeta="educacion"
    columnas={COLUMNAS}
    extensiones=".xls,.xlsx"
    ayuda={(
      <>
        Sube el Excel <strong>Detalle_DJ_11_{anioTributario}00_&lt;RUT&gt;.xlsx</strong> que descargas del SII en
        Información de terceros: el formulario de cesión del crédito por gastos en educación, con una fila por hijo o
        hija. El nombre del archivo tiene que traer el año y el RUT, porque el contenido no los trae. El archivo no se
        guarda.
      </>
    )}
  />
);

export default EducacionPage;
